module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": _vm.width,
      "mask-closable": false,
      "closable": _vm.closable,
      "footer-hide": _vm.footerhide,
      "styles": _vm.styles,
      "fullscreen": _vm.fullscreen
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_vm._t("title", null, {
    "slot": "header"
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm._t("footer", null, {
    "slot": "footer"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01b82b75"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/shared/libs/ClientFramework/packages/basicElement/dialog/LmsDialog.vue
// module id = 911
// module chunks = 80